export default {
  ADMIN: 1,
  MARKETER: 2,
  APPROVER: 3,
  IN_HOUSE_DESIGNER: 4
};
